import { render } from "./Recommenders.vue?vue&type=template&id=ef7035d4&scoped=true"
import script from "./Recommenders.vue?vue&type=script&lang=js"
export * from "./Recommenders.vue?vue&type=script&lang=js"

import "./Recommenders.vue?vue&type=style&index=0&id=ef7035d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7035d4"]])

export default __exports__